import Vue from "vue";
import Router from "vue-router";


import Kasko from "./pages/offer/Kasko.vue";
import Atb from "./pages/offer/Atb.vue";
import Cpi from "./pages/offer/Cpi.vue";
import Feedback from "./pages/feedback/Feedback.vue";
import Card from "./pages/ecard/Card.vue";

import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/offer/kasko",
      name: "OfferKasko",
      components: { default: Kasko },
    },
    {
      path: "/offer/cpi",
      name: "OfferCpi",
      components: { default: Cpi },
    },
    {
      path: "/feedback",
      name: "Feddback",
      components: { default: Feedback },
    },
    {
      path: "/offer/atb",
      name: "Atb",
      components: { default: Atb },
    },
    {
      path: "/ecard",
      name: "Card",
      components: { default: Card },
    },
    // {
    //   path: "/",
    //   name: "index",
    //   components: { default: Index, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/sections",
    //   name: "sections",
    //   components: { default: Sections, header: MainNavbar },
    //   props: {
    //     header: { colorOnScroll: 0, navbarTransparent: false }
    //   }
    // },
    // {
    //   path: "/presentation",
    //   name: "presentation",
    //   components: {
    //     default: Presentation,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true },
    //     footer: { type: "white" }
    //   }
    // },
    // {
    //   path: "/about-us",
    //   name: "about-us",
    //   components: { default: AboutUs, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/blog-post",
    //   name: "blog-post",
    //   components: { default: BlogPost, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/blog-posts",
    //   name: "blog-posts",
    //   components: {
    //     default: BlogPosts,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/contact-us",
    //   name: "contact-us",
    //   components: {
    //     default: ContactUs,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 0, navbarTransparent: false, type: "dark" }
    //   }
    // },
    // {
    //   path: "/pricing-page",
    //   name: "pricing-page",
    //   components: {
    //     default: Pricing,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/shopping-cart",
    //   name: "shopping-cart",
    //   components: {
    //     default: Shopping,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/ecommerce-page",
    //   name: "ecommerce-page",
    //   components: {
    //     default: Ecommerce,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true },
    //     footer: { type: "black", size: "big" }
    //   }
    // },
    // {
    //   path: "/product-page",
    //   name: "product-page",
    //   components: {
    //     default: Product,
    //     header: MainNavbar,
    //     footer: MainFooter
    //   },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/landing-page",
    //   name: "landing",
    //   components: { default: Landing, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/login-page",
    //   name: "login",
    //   components: { default: Login, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/profile-page",
    //   name: "profile",
    //   components: { default: Profile, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/signup-page",
    //   name: "signup",
    //   components: { default: Signup, header: MainNavbar },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // },
    // {
    //   path: "/error-page",
    //   name: "error",
    //   components: { default: Error, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400, navbarTransparent: true }
    //   }
    // }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
